import { useQuery } from '@tanstack/react-query';
import { useApiMutation } from '@/hooks/useApi';
import { pluginApi } from '@/lib/api';
import { Switch } from '@/components/ui/switch';
import { CommandsContent } from './DashboardComponents';
import { useI18n } from '@/contexts/I18nContext';

export function CustomCommandsPlugin({ serverId }: { serverId: string }) {
  const { t } = useI18n();
  const { data: plugins = [] } = useQuery({
    queryKey: ['servers', serverId, 'plugins'],
    queryFn: () => pluginApi.getPlugins(serverId),
  });

  const customCommandsPlugin = (plugins as any[]).find((plugin) => plugin.pluginId === 'custom-commands');
  const isEnabled = customCommandsPlugin?.enabled ?? false;

  const { mutate: togglePlugin } = useApiMutation(
    ({ enabled }: { enabled: boolean }) =>
      enabled ? pluginApi.enablePlugin(serverId, 'custom-commands') : pluginApi.disablePlugin(serverId, 'custom-commands'),
    { invalidateQueries: [['servers', serverId, 'plugins']] }
  );

  return (
    <div className="space-y-6">
      <div className="glass-card p-6 flex items-center justify-between border-b border-white/10">
        <div>
          <h3 className="font-bold text-xl">Custom Commands</h3>
          <p className="text-sm text-muted-foreground">{t('customCommands.subtitle')}</p>
        </div>
        <Switch checked={isEnabled} onCheckedChange={(enabled) => togglePlugin({ enabled })} />
      </div>

      <CommandsContent serverId={serverId} />
    </div>
  );
}
